import { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const translations = useMemo(() => {
    return {
      title: formatMessage(messages.title),
      btnCancel: formatMessage(messages.btnCancel),
      btnArchive: formatMessage(messages.btnArchive),
    };
  }, [formatMessage]);
  return translations;
};
export default useTranslations;
